import script from "./deferItems.vue?vue&type=script&setup=true&lang=js"
export * from "./deferItems.vue?vue&type=script&setup=true&lang=js"

import "./deferItems.vue?vue&type=style&index=0&id=a3cc52e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3cc52e6"]])

export default __exports__